module.exports = __webpack_public_path__ + "img/tfwm-logo-icon.359e95ab.png";